import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React from 'react';
import PropTypes from 'prop-types';
import { get, includes } from 'lodash';
import HoursOfOperationV2 from '@unite-us/client-utils/dist/hours/HoursOfOperationV2';
import RowDisplay from '../common/RowDisplay';
import updateContactPreference from './actions/updateContactPreference';
import updatePreferredLanguages from './actions/updatePreferredLanguages';
import enums from '../../constants/enums';
import { ContactNotesEdit, MethodsOfContactEdit, MethodsOfContact, TimeslotsEdit, VoiceMailOk, PreferredLanguagesEdit } from './components';
import { callbacks } from '../../config/api';
export var ContactRequirements = function ContactRequirements(props) {
  var _context, _context2;
  var contact = props.contact,
    shouldShowPreferredLanguages = props.shouldShowPreferredLanguages;
  var contactEnums = get(enums, 'contact_data.communication_preferences.methods_of_contact', []);
  var _ref = (contact === null || contact === void 0 ? void 0 : contact.contact_preference) || {},
    _ref$preferred_contac = _ref.preferred_contact_methods,
    preferred_contact_methods = _ref$preferred_contac === void 0 ? [] : _ref$preferred_contac,
    voice_mail_ok = _ref.voice_mail_ok,
    timeslots = _ref.timeslots,
    contact_notes = _ref.contact_notes;
  var preferredLanguages = (contact === null || contact === void 0 ? void 0 : contact.preferred_languages) || [];
  var spokenLanguages = _filterInstanceProperty(preferredLanguages).call(preferredLanguages, function (item) {
    return item.record_language_type === 'spoken';
  });
  var writtenLanguages = _filterInstanceProperty(preferredLanguages).call(preferredLanguages, function (item) {
    return item.record_language_type === 'written';
  });
  var spokenLanguagesIds = _mapInstanceProperty(spokenLanguages).call(spokenLanguages, function (item) {
    var _item$language;
    return item === null || item === void 0 || (_item$language = item.language) === null || _item$language === void 0 ? void 0 : _item$language.id;
  });
  var writtenLanguagesIds = _mapInstanceProperty(writtenLanguages).call(writtenLanguages, function (item) {
    var _item$language2;
    return item === null || item === void 0 || (_item$language2 = item.language) === null || _item$language2 === void 0 ? void 0 : _item$language2.id;
  });
  var spokenLanguagesNames = _sortInstanceProperty(_context = _mapInstanceProperty(spokenLanguages).call(spokenLanguages, function (item) {
    return item === null || item === void 0 ? void 0 : item.language_name;
  })).call(_context);
  var writtenLanguagesNames = _sortInstanceProperty(_context2 = _mapInstanceProperty(writtenLanguages).call(writtenLanguages, function (item) {
    return item === null || item === void 0 ? void 0 : item.language_name;
  })).call(_context2);
  var initialValues = _objectSpread({}, contact === null || contact === void 0 ? void 0 : contact.contact_preference);
  var showVoiceMailOk = includes(preferred_contact_methods, 'phone') && voice_mail_ok != null;
  var handleUpdateContactPreference = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(formValues) {
      return _regeneratorRuntime.wrap(function _callee$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return updateContactPreference({
              contact: contact,
              formValues: formValues
            }).then(function () {
              callbacks.onClientSaved();
            });
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee);
    }));
    return function handleUpdateContactPreference(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleUptadePreferredLanguages = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formValues) {
      return _regeneratorRuntime.wrap(function _callee2$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return updatePreferredLanguages(contact, formValues);
          case 2:
            callbacks.onClientSaved();
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee2);
    }));
    return function handleUptadePreferredLanguages(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "contact-requirements row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/React.createElement("h3", null, "Contact Requirements"), shouldShowPreferredLanguages && /*#__PURE__*/React.createElement(RowDisplay, {
    label: "Preferred Languages",
    editSection: /*#__PURE__*/React.createElement(PreferredLanguagesEdit, {
      initialValues: {
        preferred_spoken_languages: spokenLanguagesIds,
        preferred_written_languages: writtenLanguagesIds
      },
      updatePreferredLanguages: handleUptadePreferredLanguages
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 mt-1.5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "whitespace-pre-wrap"
  }, "Spoken: ", spokenLanguagesNames.length > 0 ? spokenLanguagesNames.join(', ') : '--')), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "whitespace-pre-wrap"
  }, "Written: ", writtenLanguagesNames.length > 0 ? writtenLanguagesNames.join(', ') : '--'))))), /*#__PURE__*/React.createElement(RowDisplay, {
    className: "methods-of-contact",
    label: "Methods of Contact",
    editSection: /*#__PURE__*/React.createElement(MethodsOfContactEdit, {
      contactEnums: contactEnums,
      initialValues: initialValues,
      updateContactPreference: handleUpdateContactPreference
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-6 mt-1.5"
  }, /*#__PURE__*/React.createElement(MethodsOfContact, {
    contactMethods: preferred_contact_methods,
    enums: enums
  })), showVoiceMailOk && /*#__PURE__*/React.createElement("div", {
    className: "col-sm-6 mt-1.5"
  }, /*#__PURE__*/React.createElement(VoiceMailOk, {
    contactMethods: preferred_contact_methods,
    isVoicemailOK: voice_mail_ok
  }))), /*#__PURE__*/React.createElement(RowDisplay, {
    className: "hours-of-operation",
    label: "Times to Contact",
    editSection: /*#__PURE__*/React.createElement(TimeslotsEdit, {
      contactEnums: contactEnums,
      initialValues: initialValues,
      updateContactPreference: handleUpdateContactPreference
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 mt-1.5"
  }, /*#__PURE__*/React.createElement(HoursOfOperationV2, {
    hours: timeslots,
    showAll: true,
    hideLabel: true,
    closedText: "Do not contact",
    startTimeKey: "start_time",
    endTimeKey: "end_time",
    shouldStartWeekToday: false,
    abbreviateDays: false
  }))), /*#__PURE__*/React.createElement(RowDisplay, {
    className: "contact-notes",
    label: "Contact Notes",
    editSection: /*#__PURE__*/React.createElement(ContactNotesEdit, {
      initialValues: initialValues,
      updateContactPreference: handleUpdateContactPreference
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 mt-1.5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "whitespace-pre-wrap",
    "data-test-element": "contact-notes-display"
  }, contact_notes)))));
};
ContactRequirements.propTypes = {
  contact: PropTypes.object.isRequired,
  shouldShowPreferredLanguages: PropTypes.bool
};
export default ContactRequirements;
//# sourceMappingURL=index.js.map